import "./goal.css";
import { useGSAP } from "@gsap/react";
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
const Goal = () => {
  const scrollConfig = {
          trigger: ".tab-container",
          start: "top 80%",
          end: "top 70%",
          scrub: 1,
        }
        
          useGSAP(() => {
      const tl8 = gsap.timeline();
      tl8.from(".tab-1", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
       tl8.from(".tab-2", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
       tl8.from(".tab-3", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
       tl8.from(".tab-4", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
       tl8.from(".tab-5", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
       tl8.from(".tab-6", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
       tl8.from(".tab-7", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
       tl8.from(".tab-8", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
        tl8.from(".tab-9", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
        tl8.from(".tab-10", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });

       
    });
  return (
    <>
     <section className="goal py-4">
  <div className="container">
  <div className="position-relative heading-container mx-auto ">
                       <h2 className="heading">
                        G<span className="heading-span">OAL</span>    </h2>
                      <div className="line"></div>
                    </div>
    <div className="row tab-container">
    
      <div className="col-sm-12 col-md-3 col-lg-3 p-4 ">
        <div className="col-12 objectives tab-1">Integrity</div>
      </div>
      
      <div className="col-sm-12 col-md-3 col-lg-3 p-4 ">
        <div className="col-12 objectives tab-2">Teamwork</div>
        <div className="col-12 objectives mt-4 tab-5">Leadership</div>
      </div>
      
      <div className="col-sm-12 col-md-3 col-lg-3 p-4 ">
        <div className="col-12 objectives tab-3">Customer Focus</div>
        <div className="col-12 objectives mt-4 tab-6">Communication</div>
        <div className="col-12 objectives mt-4 tab-8">Accountability</div>
      </div>
      
      <div className="col-sm-12 col-md-3 col-lg-3 p-4 ">
        <div className="col-12 objectives tab-4">Productivity</div>
        <div className="col-12 objectives mt-4 tab-7">Quality</div>
        <div className="col-12 objectives mt-4 tab-9">Innovation</div>
        <div className="col-12 objectives mt-4 tab-10">Responsibility</div>
      </div>

    </div>
  </div>
</section>

    </>
  );
};
export default Goal;
